/**
 * Quiz confidence from score % — Sun / Moon / Star (Figma).
 *
 * Display + severity order (best → needs help):
 *   Sun  → High confidence
 *   Moon → Moderate confidence
 *   Star → Needs support
 */

export type QuizConfidenceIndicator = "sun" | "moon" | "star";

/** Canonical top→bottom order for confidence UI. */
export const QUIZ_CONFIDENCE_ORDER: QuizConfidenceIndicator[] = [
  "sun",
  "moon",
  "star",
];

export const QUIZ_CONFIDENCE_LABELS: Record<QuizConfidenceIndicator, string> = {
  sun: "High confidence",
  moon: "Moderate confidence",
  star: "Needs support",
};

export const QUIZ_CONFIDENCE_SHORT: Record<QuizConfidenceIndicator, string> = {
  sun: "Sun",
  moon: "Moon",
  star: "Star",
};

export function quizScorePercent(score: number, maxScore: number): number {
  if (maxScore <= 0) return 0;
  return Math.round((score / maxScore) * 100);
}

export function resolveQuizConfidence(
  scorePercent: number,
): QuizConfidenceIndicator {
  if (scorePercent >= 75) return "sun";
  if (scorePercent >= 50) return "moon";
  return "star";
}

export function countConfidenceIndicators(
  percents: number[],
): Record<QuizConfidenceIndicator, number> {
  const counts = { sun: 0, moon: 0, star: 0 };
  for (const p of percents) {
    counts[resolveQuizConfidence(p)] += 1;
  }
  return counts;
}
